import * as React from "react";
import "./CheckBox.css";
import { CustomCheckbox } from "./Checkbox";

export interface ICheckBoxGroupProps {
    title?: React.ReactNode;
    options: Array<{
        label: string;
        checked: boolean;
        disabled?: boolean;
        optionId: number | string;
    }>;
    componentId: string;
    onChange: (checked: boolean, optionId: number | string) => void;
    inline?: boolean;
}

export const CheckBoxGroup = (props: ICheckBoxGroupProps) => {
    return (
        <div className="checkbox-group-container">
            {
                props.title &&
                <h2>{props.title}</h2>
            }
            <div className={`${props.inline ? "inline" : ""}`}>
                {
                    props.options.map(opt => (
                        <CustomCheckbox
                            key={`${props.componentId}-checkbox-${opt.optionId}`}
                            {...opt}
                            onClick={() => props.onChange(!opt.checked, opt.optionId)}
                        />
                    ))
                }
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/customFormComponents/CheckBoxGroup/CheckBoxGroup.tsx